import type { Pagination } from '@talentmesh/utils';

/**
 * check if out of bound, will return last page, otherwise it's not out of bound
 * @tldr just use this if you're making a server-side pagination without backend safe guard
 * @description
 * when there are 2 recruiters managing a recruitment, say recruiter A is on page 1, and recruiter B is on page 3. Recruiter A will be shortlisting 20 candidates, while recruiter B is going to hide 1 candidate. If recruiter A went first, recruiter B should be positioned at page 2 because 20 candidates have been removed from that table. Once recruiter B hide the 1 candidate on his page, it will reload the table and show nothing because there are only 40 candidates total and recruiter B is out of bound. Therefore I am introducing a check where if the pagination data that came in is out of bound, it will automatically put the recruiter in the right position
 * */
const checkOutOfBound = ({ limit, offset, totalCount }: Pagination) => {
    if (totalCount !== 0 && offset >= totalCount) {
        const lastPageOffset = limit > totalCount ? 0 : (Math.ceil(totalCount / limit) - 1) * limit;
        const lastPage: Pagination = { limit, offset: lastPageOffset, totalCount };
        return lastPage;
    }

    return null;
};

export default checkOutOfBound;
